class GestorCobertura {
    // Coordenadas del polígono [longitud, latitud]
    // Extraídas del GeoJSON proporcionado
    /*static POLYGON = [
        [-63.23953337628509, -17.753887695532395],
        [-63.23568036811232, -17.751944477929666],
        [-63.23507290855598, -17.746492333147327],
        [-63.232814494478596, -17.741247764932357],
        [-63.228163577975224, -17.73464134371479],
        [-63.22219303397196, -17.728990175753527],
        [-63.213594011368706, -17.725479901589537],
        [-63.211786327342374, -17.727487851487314],
        [-63.21292707852967, -17.73637610551519],
        [-63.212485377198774, -17.738971178014765],
        [-63.21239493770093, -17.739059535029998],
        [-63.20861281018962, -17.74039117478644],
        [-63.20850279369303, -17.740376210059154],
        [-63.19794145856826, -17.734394581325144],
        [-63.195563445277045, -17.729394976190065],
        [-63.195202287737466, -17.727526129373707],
        [-63.195652474999925, -17.725280452109807],
        [-63.19187078147845, -17.721425333909274],
        [-63.190828142196814, -17.72311731329483],
        [-63.19071527767386, -17.723176472616924],
        [-63.19059764190424, -17.723127482295048],
        [-63.19026959431855, -17.722454433778626],
        [-63.18698822819805, -17.714814313173296],
        [-63.187290695473244, -17.712353304984504],
        [-63.18733235048823, -17.712266884711696],
        [-63.19390637264368, -17.70766735566775],
        [-63.195168294237135, -17.703951809409187],
        [-63.19566651827756, -17.701476377515668],
        [-63.197799615711304, -17.69847768178318],
        [-63.19771111617383, -17.69490547381533],
        [-63.19707706802577, -17.693288785923407],
        [-63.19612726805958, -17.686899531010013],
        [-63.19314469749196, -17.681561189286718],
        [-63.18857418278495, -17.675795949539786],
        [-63.1782209273923, -17.667019823786966],
        [-63.173647456946426, -17.66417178657677],
        [-63.17202761456238, -17.657918783517893],
        [-63.1649521006195, -17.655572540435394],
        [-63.157556091583515, -17.658150068120406],
        [-63.157850075150975, -17.663954072118454],
        [-63.15783599488691, -17.66402552441256],
        [-63.15777771383806, -17.664090125057367],
        [-63.149285353879336, -17.66455113992957],
        [-63.1385833864815, -17.66755657651716],
        [-63.13100888360892, -17.67571925151047],
        [-63.12358987985406, -17.690566526472722],
        [-63.121411942801096, -17.700854124594006],
        [-63.12118133551355, -17.7076865898372],
        [-63.13489567881418, -17.727939489972997],
        [-63.134892213140766, -17.728039289814742],
        [-63.13482686420008, -17.728114798325887],
        [-63.13025259094531, -17.73072225839625],
        [-63.13655155750859, -17.740548419732455],
        [-63.139504159239046, -17.745294801382414],
        [-63.139522238300145, -17.74541080183832],
        [-63.13945123034876, -17.74550429423941],
        [-63.12905902675858, -17.751443046553412],
        [-63.14232891264856, -17.77313150436862],
        [-63.147032400124864, -17.78954435293503],
        [-63.157184781292095, -17.79561117686597],
        [-63.167696041011546, -17.800903971054538],
        [-63.17446965856091, -17.801685626016976],
        [-63.186038285458025, -17.8018541234486],
        [-63.19516547713095, -17.801906548557177],
        [-63.20833680004844, -17.812896076158367],
        [-63.2133470572963, -17.806266918191344],
        [-63.21562337983466, -17.801675390227725],
        [-63.21688812803524, -17.797830418606804],
        [-63.217499303888786, -17.79194182091378],
        [-63.21758464769672, -17.785928808281167],
        [-63.216603204063034, -17.776283895034574],
        [-63.2044729077258, -17.762699566110772],
        [-63.20311763561032, -17.759368074712384],
        [-63.20312311625158, -17.75924342816447],
        [-63.20931709341389, -17.751326518679836],
        [-63.2094023299331, -17.751299889184445],
        [-63.213781859453675, -17.751315550016347],
        [-63.213859946368586, -17.75143534232074],
        [-63.214616061005856, -17.760766637586165],
        [-63.21608317793727, -17.76446521952004],
        [-63.219659168353, -17.765249446773897],
        [-63.21973595954121, -17.76529282917313],
        [-63.222527150006, -17.770914698344527],
        [-63.22491476577907, -17.77024814178327],
        [-63.225002305758835, -17.77025023289681],
        [-63.225064138436856, -17.77028959644925],
        [-63.225103080542205, -17.770368025609923],
        [-63.22509159666067, -17.770454834257404],
        [-63.22412987548154, -17.772564890920126],
        [-63.227840495822065, -17.776090721181664],
        [-63.22925689980059, -17.77433722505921],
        [-63.232404814733435, -17.77345759543071],
        [-63.23250039296578, -17.77349528562131],
        [-63.23572743243332, -17.776355004052874],
        [-63.238417268100235, -17.758821178949997],
        [-63.2378131139427, -17.75693722488409],
        [-63.23953337628509, -17.753887695532395]
    ];*/

    static POLYGON = [
        [-63.239520116961714, -17.75388764932335],
        [-63.23566621076242, -17.751949913894748],
        [-63.23507302928234, -17.746499965109017],
        [-63.232809245496206, -17.741237481825717],
        [-63.228142215612, -17.7346361518467],
        [-63.222187728178376, -17.72899519443925],
        [-63.21361543462049, -17.725489970999256],
        [-63.211791574226666, -17.7275133632724],
        [-63.212928206162076, -17.736370843623707],
        [-63.21248056042699, -17.73899028838765],
        [-63.21245072807626, -17.739019658712174],
        [-63.208579115142925, -17.7404136025364],
        [-63.197949821376135, -17.734436350193857],
        [-63.195558557597636, -17.729391552354233],
        [-63.19520031908086, -17.72751334905934],
        [-63.19564455453907, -17.725290634215888],
        [-63.191868077357874, -17.721432805788034],
        [-63.19073118729634, -17.72326535412482],
        [-63.19069064193597, -17.723288958651764],
        [-63.1906514621112, -17.723272364497372],
        [-63.190269975518724, -17.722462114142665],
        [-63.18698525218042, -17.71482009039025],
        [-63.18731006598331, -17.71228035998076],
        [-63.193906487973926, -17.70766744225616],
        [-63.19516934213578, -17.703948723491756],
        [-63.195664434455054, -17.70147547641521],
        [-63.19779971991987, -17.698477715407734],
        [-63.19771121147572, -17.694905454454194],
        [-63.1970787552777, -17.693300137820735],
        [-63.196127365822115, -17.686899497684397],
        [-63.19314476468323, -17.68156114430734],
        [-63.188574270339956, -17.67579586481257],
        [-63.178220967344025, -17.6670197689312],
        [-63.173635182639785, -17.664168962714676],
        [-63.1720277159905, -17.657918688889346],
        [-63.164952099755354, -17.655572426365662],
        [-63.157555969170986, -17.658149985730528],
        [-63.15785512936959, -17.66405379544251],
        [-63.15783100893195, -17.66409914642215],
        [-63.14928532893795, -17.664550988231003],
        [-63.138583330492416, -17.667556484841047],
        [-63.13100879069618, -17.675719187162315],
        [-63.123589796021086, -17.69056649313724],
        [-63.12141184785672, -17.700854113031383],
        [-63.12118119877735, -17.707686629285615],
        [-63.134943682768586, -17.728002851696026],
        [-63.134920744563885, -17.728061287813656],
        [-63.13025243784684, -17.730722220713528],
        [-63.136555873093116, -17.740555151682432],
        [-63.13955901885931, -17.745382950292473],
        [-63.13956504521301, -17.74542161711111],
        [-63.13954137589588, -17.745452781244804],
        [-63.12905886111019, -17.75144300403331],
        [-63.142331658016644, -17.7731352147032],
        [-63.14703230730481, -17.78954442431479],
        [-63.15718632991411, -17.795612102257],
        [-63.16769601310087, -17.800904064348174],
        [-63.17446714931968, -17.801685589470328],
        [-63.18603706848785, -17.80185410326251],
        [-63.19516033612926, -17.801898943924066],
        [-63.21436643873942, -17.818258802422108],
        [-63.22127577586551, -17.813253811000198],
        [-63.2286130615402, -17.804266430427003],
        [-63.23202603498647, -17.80071000122716],
        [-63.23185439020123, -17.79948421724379],
        [-63.23057292673367, -17.79816972360418],
        [-63.23129647517405, -17.79523460121639],
        [-63.22897939416593, -17.79143424804594],
        [-63.22721978353453, -17.786204449848103],
        [-63.226189043986366, -17.783586669969328],
        [-63.22533100646494, -17.780788486246315],
        [-63.2245587871138, -17.778766474509993],
        [-63.21988317555475, -17.77766354420459],
        [-63.216592757549215, -17.77657362423998],
        [-63.204476476852115, -17.76271753867186],
        [-63.20304779599466, -17.759282202850976],
        [-63.209341273898076, -17.751290852256744],
        [-63.213807855350616, -17.751288052080774],
        [-63.21383391779922, -17.751327774256698],
        [-63.21464544119055, -17.760784547188077],
        [-63.21606163648046, -17.7644218943671],
        [-63.219625810930225, -17.765166925124426],
        [-63.222541858656854, -17.770909763491417],
        [-63.2241301549104, -17.77256537814876],
        [-63.22784184803175, -17.776048744732137],
        [-63.22924253085755, -17.77429104454879],
        [-63.23237952656079, -17.77341836792073],
        [-63.2356953236468, -17.77631435324972],
        [-63.238409579075444, -17.758834160103707],
        [-63.23780356821771, -17.756927893875087],
        [-63.239520116961714, -17.75388764932335]
    ];

    /**
     * FUNCIÓN PRINCIPAL - Verifica si un punto está dentro del polígono
     * @param {number} lat - Latitud del punto (-90 a 90)
     * @param {number} lng - Longitud del punto (-180 a 180)
     * @returns {boolean} true = dentro, false = fuera
     */
    static dentroDelPoligono(lat, lng) {
        let dentro = false;           // Contador de intersecciones (par/impar)
        const len = this.POLYGON.length;   // Cache del tamaño para optimizar

        // Recorrer cada lado del polígono
        for (let i = 0, j = len - 1; i < len; j = i++) {
            // Coordenadas del lado actual
            const [x1, y1] = this.POLYGON[i];  // Punto actual [lng, lat]
            const [x2, y2] = this.POLYGON[j];  // Punto anterior [lng, lat]

            // ALGORITMO RAY CASTING
            if (((y1 > lat) !== (y2 > lat)) &&
                (lng < (x2 - x1) * (lat - y1) / (y2 - y1) + x1)) {
                dentro = !dentro;
            }
        }

        return dentro;
    }
}

